import { render, staticRenderFns } from "./NestedEditors.vue?vue&type=template&id=128bfb9a"
import script from "./NestedEditors.vue?vue&type=script&lang=js"
export * from "./NestedEditors.vue?vue&type=script&lang=js"
import style0 from "./NestedEditors.vue?vue&type=style&index=0&id=128bfb9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports